import type { ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import { usePermission } from '@/hooks/usePermission';
import { useBudgetScope } from './shared';

const CLAIM_PERMISSIONS = ['hr.employees.read', 'accounting.journals.approve'];

/**
 * Guard for the expense-claims list. HR and Finance (accounting.journals.approve) get in, and so
 * does a department head, who holds neither: the API shows a head only their own department's claims.
 */
export default function ClaimsAccessRoute({ children }: { children: ReactNode }) {
  const { hasAnyPermission } = usePermission();
  const scope = useBudgetScope();
  if (hasAnyPermission(CLAIM_PERMISSIONS)) return <ProtectedRoute>{children}</ProtectedRoute>;
  if (scope.loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}><CircularProgress /></Box>;
  }
  if (scope.headOf.length > 0) return <ProtectedRoute>{children}</ProtectedRoute>;
  return <ProtectedRoute requiredPermission={CLAIM_PERMISSIONS}>{children}</ProtectedRoute>;
}
